<div *ngIf="page_count">
  <div class="col">
    <br>
    <nav aria-label="Page navigation example">
      <ul class="pagination justify-content-center"  style="margin-bottom: 0px;">
        <li 
          class="page-item" 
          [ngClass]="{'disabled': isPrevDisabled()}" 
          *ngIf="page_arr.length > 1">
          <a 
            class="page-link outpg" 
            href="javascript:void(0)" 
            (click)="!isPrevDisabled() && pre_click_page()" 
            aria-label="Previous"> 
            <span aria-hidden="true">«</span> 
            <span class="sr-only">前一頁</span> 
          </a>
        </li>
        <li 
          class="page-item" 
          [ngClass]="data.page == page ? 'active' : ''" 
          *ngFor="let page of page_arr; let i = index" 
          (click)="click_page(page)">
          <a 
            href="javascript:void(0)" 
            class="page-link outpg">{{page * 1 + 1}}
          </a>
        </li>
        <li 
          class="page-item" 
          [ngClass]="{'disabled': isNextDisabled()}" 
          *ngIf="page_arr.length > 1">
          <a 
            class="page-link outpg" 
            href="javascript:void(0)" 
            (click)="!isNextDisabled() && aft_click_page()" 
            aria-label="Next"> 
            <span aria-hidden="true">»</span> 
            <span class="sr-only">下一頁</span> 
          </a>
        </li>
      </ul>
    </nav>
  </div>
</div>
